import type { GridFilterModel } from '@mui/x-data-grid-pro';
import type { IssuesQuery } from 'shared/domain/issue/issueQuery';
import type { PaginationData } from 'shared/filter/types';
import { standariseFilters, toSingleFilters } from 'shared/utils/filters';
import type { IssueGridParameters } from '../slices/issueParameters/types';
import { gridFilterModelToFilterGroup } from './filterModel/filterModel';

interface IssuesQuerySource {
  parameters: Pick<IssueGridParameters, 'search' | 'sort' | 'deleted'>;
  filterModel: GridFilterModel;
  timezone: string;
  /** Without a page every matching issue is read. */
  pagination?: PaginationData;
}

/** The issue grid's state (search, filters, sort, archived) as a query for the worker. */
export function buildIssuesQuery({ parameters, filterModel, timezone, pagination }: IssuesQuerySource): IssuesQuery {
  return {
    filter: gridFilterModelToFilterGroup(filterModel),
    search: toSingleFilters(
      standariseFilters(parameters.search ? [{ name: 'search', value: parameters.search }] : [])
    ),
    sort: parameters.sort,
    archived: parameters.deleted,
    timezone,
    pagination,
  };
}
